import React, { FC } from "react";
import { Card, DatePicker, Select, Space } from "antd";
import dayjs from "dayjs";
import { FilterOptions, OverviewFilterParam } from "../types/overview";

const { RangePicker } = DatePicker;
const { Option } = Select;

interface AnalyticsFiltersProps {
  filters: OverviewFilterParam;
  filterOptions: FilterOptions | null;
  onDateRangeChange: (dates: any, dateStrings: [string, string]) => void;
  onFilterChange: (key: string, value: string) => void;
  loading?: boolean;
  showEmailDomain?: boolean;
}

const AnalyticsFilters: FC<AnalyticsFiltersProps> = ({
  filters,
  filterOptions,
  onDateRangeChange,
  onFilterChange,
  loading = false,
  showEmailDomain = true,
}) => {
  return (
    <Card style={{ marginBottom: "24px" }}>
      <Space wrap size="middle">
        <RangePicker
          onChange={onDateRangeChange}
          disabled={loading}
          value={filters.start_date && filters.end_date ? [dayjs(filters.start_date), dayjs(filters.end_date)] : null}
        />

        <Select
          placeholder="Select Country"
          style={{ width: 150 }}
          onChange={(value) => onFilterChange("country", value)}
          allowClear
          disabled={loading}
          value={filters.country}
        >
          <Option value="all">All Countries</Option>
          {filterOptions?.countries.map((country) => (
            <Option key={country} value={country}>
              {country}
            </Option>
          ))}
        </Select>

        <Select
          placeholder="Select Browser"
          style={{ width: 150 }}
          onChange={(value) => onFilterChange("browser", value)}
          allowClear
          disabled={loading}
          value={filters.browser}
        >
          <Option value="all">All Browsers</Option>
          {filterOptions?.browsers.map((browser) => (
            <Option key={browser} value={browser}>
              {browser}
            </Option>
          ))}
        </Select>

        {showEmailDomain && (
          <Select
            placeholder="Select Email Domain"
            style={{ width: 180 }}
            onChange={(value) => onFilterChange("email_domain", value)}
            allowClear
            disabled={loading}
            value={filters.email_domain}
          >
            <Option value="all">All Email Domains</Option>
            {filterOptions?.email_domains.map((domain) => (
              <Option key={domain} value={domain}>
                {domain}
              </Option>
            ))}
          </Select>
        )}
      </Space>
    </Card>
  );
};

export default AnalyticsFilters;
